import { RECEIVE_GENERAL_INFO } from '../constants/ActionTypes';

const generalInfo = (state = null, action) => {
  switch (action.type) {
    case RECEIVE_GENERAL_INFO:
      return action.data
    default:
      return state;
  }
}

export default generalInfo;



// WEBPACK FOOTER //
// ./src/reducers/generalInfo.js